import React from 'react'
import './PriceWithSymbol.css'

type PriceWithSymbol = {
  amount: any
  format: string
  symbol: string
  spanClassName?: string
}

function PriceWithSymbol({
  amount,
  format = 'right',
  symbol = '€',
  spanClassName = ''
}: PriceWithSymbol) {
  try {
    amount = amount.toFixed(2)
  } catch (err) {
    console.log(err)
  }
  return (
    <span className='cocunat-PriceWithSymbol'>
      {format === 'left' ? (
        amount < 0 ? (
          <span className={spanClassName}>
            -{symbol}
            {(-1 * amount).toFixed(2)}
          </span>
        ) : (
          <span className={spanClassName}>
            {symbol}
            {amount}
          </span>
        )
      ) : (
        <span className={spanClassName}>
          {amount}
          {symbol}
        </span>
      )}
    </span>
  )
}

export default PriceWithSymbol
